import React from 'react';

/** Instagram favourite facts that require auth before showing values publicly. */
export const INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH = [
  'Engagement Rate',
  'Views',
  'Average Views Per Post',
  'Account Reach'
];

/** Single canonical label for the paid Instagram “highest engagement” stat. */
export const INSTAGRAM_FACT_NAME_HIGHEST_ENGAGEMENT = 'Highest engagement';

export const isInstagramStatShieldedWhenUnauthenticated = stat =>
  stat?.socialChannelName?.toLowerCase() === 'instagram' &&
  INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH.includes(stat?.factName);

const isNumericValue = val =>
  /^-?\d+(\.\d+)?$/.test(String(val ?? '').trim());

/**
 * Rows accepted by UpdateFavFacts (must include platform + name).
 */
export const filterFavFactsForApi = factsListLocal =>
  (factsListLocal || []).filter(item => item?.factName && item?.socialChannelName);

/**
 * Renders the main headline value for a favourite-facts card (aligned with PaidFavouriteFacts).
 *
 * @param {object} params
 * @param {object} params.stat - fact row (factName, factValue, socialChannelName; themes may set `value` for Age Range)
 * @param {boolean} params.isInstagramAuthenticated
 * @param {(raw: string|number) => string|number} params.formatNumber - project formatter
 * @param {() => React.ReactNode} params.renderShield
 */
export const renderFavouriteFactValue = ({
  stat,
  isInstagramAuthenticated,
  formatNumber,
  renderShield
}) => {
  const raw = stat?.factValue;
  const factName = stat?.factName;

  if (factName === 'Age Range' || factName === 'Ilola Rating') {
    return raw || 0;
  }

  if (isInstagramStatShieldedWhenUnauthenticated(stat) && !isInstagramAuthenticated) {
    return renderShield();
  }

  if (isNumericValue(raw)) {
    return formatNumber(raw, 1, true) || 0;
  }

  return raw || '';
};
